function shortenString(str, maxLength) {
    if (str.length <= 100) {
        return str; // Return the string as is if it's already within or equal to the maxLength
    } else {
        return str.substring(0, 100).trim() + '...'; // Return the truncated string with an ellipsis
    }
}


export { shortenString };